module.exports = {
	"articleTitle1": "Law School hosts discussion of former and future health care acts ...",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Law School",
	"articleLink1": "https://www.michigandaily.com/section/government/law-school-student-groups-host-discussion-concerning-aca-repeal-and-replacement",
	"articleLink2": "https://www.michigandaily.com/section/campus-life/former-us-attorney-university-michigan-alum-barbara-mcquade-join-law-school",
	"articleSnippet1": "Mar 16, 2017 ... Two student groups from the University of Michigan Law School, the Michigan \nHealth Law Organization and the Law School Democrats, hosted ...",
	"articleSnippet2": "Mar 14, 2017 ... Effective May 1, former U.S. Attorney Barbara McQuade, a University of Michigan \nalum, will join the Law School faculty as a professor of ...",
	"totalMisc": 2,
	"articleTitle2": "Former U.S. Attorney, University of Michigan alum Barbara ...",
	"address": "625 S State St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170316/11_6_16_1-4.jpg?itok=TyPaQ37T",
			"author": "Emma Richter",
			"caption": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/aak.new_.lawquadcafe.9-28-11.00019.jpg",
			"author": "Allison Kruske",
			"caption": "Students study in the new Robert B. Aikens Commons at the Law School on Wednesday, Sept. 28. The new Kirkland & Ellis Café is located inside the commons."
		}
	],
	"position": {
		"lat": 42.2743,
		"lng": -83.7401
	},
	"tips": [
		{
			"text": "(Law Commons) Best place to study on campus, gorgeous sky lighting. Tip: open to undergrads before 8:00PM on Monday through Wednesday and entirely open on Thurs-Saturday.",
			"author": "Daniel Madion"
		},
		{
			"text": "The best study spot when focus is a priority.",
			"person": "Bob Lesser"
		}
	],
	"bathroomrating": [
		{
			"rating": 5,
			"bathroom": "1st floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"bestofaa": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/lawschool.json
// module id = 905
// module chunks = 0